import Sidebar from "../../components/sidebar/Sidebar"
import Navbar from "../../components/navbar/Navbar"
import PatientByID from "../../components/patient-timeline/patientByid"

const PatientByIDContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <PatientByID />
      </div>
    </div>
  )
}

export default PatientByIDContainer;
